export default __webpack_public_path__ + "static/media/a038-4.bee01ea6.svg";